import(/* webpackMode: "eager" */ "/app/src/app/[locale]/solutions/ai-consulting/page.tsx");
